module.exports = __webpack_public_path__ + "img/logo-spy4.d97c31a3.png";